
import menu1 from "../img/menu-1.webp";
import menu2 from "../img/menu-2.png";
import menu3 from "../img/menu-3.webp";
import menu4 from "../img/menu-4.webp";
import menu5 from "../img/menu-5.webp";
import menu6 from "../img/menu-6.webp";
import menu7 from "../img/menu-7.png";
import menu8 from "../img/menu-8.webp";

import schools from "../data/schools";

let SchoolGroup1 = schools.slice(0, 9);
let SchoolGroup2 = schools.slice(10, 18);

const ProgrammesLinkGroup1 = SchoolGroup1.map((school) => ({
    title: school.title,
    url: `/school/${school.url}`,
    courses: school.courses.map((course) => ({
        title: course.title,
        url: `/course/${course.url}`,
    })),
}));

let ProgrammesLinkGroup2 = SchoolGroup2.map((school) => ({
    title: school.title,
    url: `/school/${school.url}`,
    courses: school.courses.map((course) => ({
        title: course.title,
        url: `/course/${course.url}`,
    })),
}));

const menuData = {
    "About Us": {
        Key: 1,
        eyebrow: "Discover ISBMU",
        title: "A university built around possibility.",
        description:
            "Meet the people, purpose and principles shaping an ambitious academic community.",
        groups: [
            {
                title: "About ISBM University",
                links: [
                    { title: "About ISBM University", url: "/about-us" },
                    { title: "Vision & Mission", url: "/vision-mission" },
                    {
                        title: "Leadership & Management",
                        url: "/leadership-and-management",
                    },
                    {
                        title: "University Administration",
                        url: "/university-administration",
                    },
                    { title: "Board of Advisors", url: "/board-advisor" },
                    {
                        title: "Messages of the Dignitaries",
                        url: "/dignitaries-messages",
                    },
                ],
            },
            {
                title: "Governance & Recognition",
                links: [
                    { title: "Statutes & Ordinances", url: "/statues-and-ordinance" },
                    {
                        title: "Accreditations & Recognitions",
                        url: "/accreditation-and-recognitions",
                    },
                    { title: "Awards", url: "/awards" },
                    { title: "Media Coverage", url: "/media-coverage" },
                    { title: "Code of Conduct", url: "/code-of-conduct-and-rti" },
                    { title: "Raj Bhavan", url: "https://rajbhavancg.gov.in/" },
                ],
            },
        ],
        image: menu1,
    },

    Academics: {
        eyebrow: "Learn with purpose",
        title: "Where rigorous thinking meets real-world impact.",
        description:
            "Explore an interdisciplinary academic ecosystem designed for tomorrow's challenges.",

        groups: [
            {
                title: "Academic Excellence",
                links: [
                    {
                        title: "Academic Philosophy",
                        url: "/academic-philosophy",
                    },
                    {
                        title: "Academic Partners",
                        url: "/academic-partner",
                    },
                    {
                        title: "Online Resources",
                        url: "/online-resources",
                    },
                    {
                        title: "Teaching Methodology / Pedagogy",
                        url: "/teaching-methodology-pedagogy",
                    },
                ],
            },
            {
                title: "Learning & Collaboration",
                links: [
                    {
                        title: "MOOC's with ISBM University",
                        url: "/mooc-with-isbm",
                    },
                    {
                        title: "MOU's and Collaborations",
                        url: "/mous-and-collaborations",
                    },
                    {
                        title: "Academic Calendar",
                        url: "/academic-calender",
                    },
                    {
                        title: "Blogs",
                        url: "/blog",
                    },
                ],
            },
        ],

        image: menu2,
    },

    Programmes: {
        eyebrow: "Find your programme",
        title: "Choose a path that moves you forward.",
        description:
            "Explore programmes offered across all academic schools and discover the right career path for your future.",
        groups: [
            {
                title: "Professional & Technology Schools",
                links: ProgrammesLinkGroup1,
            },
            {
                title: "Specialized & Emerging Schools",
                links: ProgrammesLinkGroup2,
            },
        ],
        image: menu3,
    },

    Admissions: {
        eyebrow: "Start your journey",
        title: "Your future begins with one bold step.",
        description:
            "Join ISBM University through a simple admission process and take the first step towards a successful career.",
        groups: [
            {
                title: "Apply & Eligibility",
                links: [
                    {
                        title: "Programmes and Eligibilities",
                        url: "/programmes-and-eligibilities",
                    },
                    {
                        title: "Programmes By Qualification",
                        url: "/programmes-by-qualification",
                    },
                    {
                        title: "Skill Development",
                        url: "/skill-development",
                    },
                    {
                        title: "Research",
                        url: "/research",
                    },
                    {
                        title: "Apply Online",
                        url: "/apply-online",
                    },
                ],
            },
            {
                title: "Payments & Assistance",
                links: [
                    {
                        title: "Online Payment",
                        url: "/pay-fees-online",
                    },
                    {
                        title: "Payment Procedure Guidelines",
                        url: "/payment-procedure-guidelines",
                    },
                    {
                        title: "Admission Procedure Guidelines",
                        url: "/admission-procedure-guidelines",
                    },
                    {
                        title: "Admission Helpdesk",
                        url: "/admission-help-desk",
                    },
                ],
            },
        ],
        image: menu4,
    },

    "Student Services": {
        eyebrow: "Here for every student",
        title: "Support that goes beyond the classroom.",
        description:
            "Resources, wellbeing and opportunities designed around your university experience.",
        groups: [
            {
                title: "Student Support",
                links: [
                    { title: "FAQ", url: "/faqs" },
                    { title: "Scholarship", url: "/scholarship" },
                    { title: "Anti-Ragging Policy", url: "/anti-ragging-policy" },
                    { title: "Download", url: "/download-form" },
                    { title: "Alumni Portal", url: "https://isbmalumni.com/" },
                    { title: "Voter Portal", url: "https://voterportal.eci.gov.in/" },
                    { title: "Anti-Ragging Committee", url: "/anti-ragging-committee" },
                    { title: "Anti-Ragging Squad", url: "/anti-ragging-squad" },
                ],
            },
            {
                title: "Committees & Student Life",
                links: [
                    { title: "Scheduled Caste and Scheduled Tribe Committee", url: "/sc-and-st-committee" },
                    { title: "Other Backward Class Committee", url: "/obc-committee" },
                    { title: "Student's Grievance Redressal Committee", url: "/student-grievance-committee" },
                    { title: "Internal Complaints Committee", url: "/icc-committee" },
                    { title: "Cultural Committee", url: "/cultural-committee" },
                    { title: "Student Council", url: "/student-council" },
                    { title: "Student ERP", url: "https://isbmuniversity.online/" },
                    { title: "Student Grievance", url: "/student-grievance" },
                ],
            },
        ],
        image: menu5,
    },

    Placements: {
        eyebrow: "Careers without limits",
        title: "Turn knowledge into professional momentum.",
        description:
            "Career preparation, industry exposure and employer connections from day one.",
        groups: [
            {
                title: "Career Development",
                links: [
                    { title: "About Placements", url: "/about-placements" },
                    { title: "Career Counselling", url: "/career-counselling" },
                    { title: "Global Readiness", url: "/global-readiness" },
                    { title: "Recruiters", url: "/recruiters" },
                    { title: "Campus Recruitment and Interview Training", url: "/campus-recruitment-interview-training" },
                    { title: "Work at ISBM University", url: "/work-at-isbmu" },
                ],
            },
        ],
        image: menu6,
    },

    Campus: {
        eyebrow: "Life at ISBMU",
        title: "A vibrant campus made for discovery.",
        description:
            "Modern learning spaces, rich student life and a community that feels like home.",
        groups: [
            {
                title: "Campus Facilities",
                links: [
                    { title: "Campus Infrastructure", url: "/campus-infrastructure", target: "_blank" },
                    { title: "Library", url: "/library", target: "_blank" },
                    { title: "Laboratory", url: "/laboratory", target: "_blank" },
                    { title: "Sports Facilities", url: "/sports-facilities", target: "_blank" },
                ],
            },
            {
                title: "Campus Experience",
                links: [
                    { title: "Extra Curricular", url: "/extra-curricular", target: "_blank" },
                    { title: "Digitized Learning System", url: "/digitized-learning-system" },
                    { title: "Bus Transportation", url: "/bus-transportation", target: "_blank" },
                    { title: "Hostel", url: "/hostel", target: "_blank" },
                ],
            },
        ],
        image: menu7,
    },

    International: {
        eyebrow: "Think globally",
        title: "A world of opportunity, within reach.",
        description:
            "Global partnerships and cross-cultural experiences that broaden every perspective.",
        groups: [
            {
                title: "Global Partnerships",
                links: [
                    { title: "International Partnerships", url: "/international-partnerships" },

                ],
            },
            {
                title: "International Students",
                links: [
                    { title: "International Students", url: "/international-students", target: "_blank" },
                ],
            },
        ],
        image: menu8,
    },
};

export default menuData;